export interface IValidate {
    valid: boolean;
    message?: string;
}

export const TELEGRAM_TRAFFIC_SOURCE_ID = '26';

export const isTelegramUrl = (url: string): boolean => {
    if (typeof url !== 'string') return false;

    try {
        const parsedUrl = new URL(url);

        return parsedUrl.hostname.toLowerCase() === 't.me';
    } catch {
        return false;
    }
};

export const isTelegramTrafficSource = (sourceId?: string): boolean =>
    sourceId === TELEGRAM_TRAFFIC_SOURCE_ID;

/**
 * Проверяем URL на валидность
 * @param {string} url
 * @returns {IValidate}
 */
export const validateUrl = (url: string, t: (key: string) => string): IValidate => {
    if (typeof url !== 'string')
        return {
            valid: false,
            message: t('Wrong url address'),
        };

    try {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(?:https?:\/\/)(?:www\.)?((?:[_-а-яa-z0-9]+[\.])+[а-яa-z]{2,17})(\/[^\s<>\"\,\{\}\\|\\\^\[\]`]*)?$/gi;
        const protocolCountsPattern = /(https?:\/\/)/g;
        const protocolCounts = ((url || '').match(protocolCountsPattern) || []).length;

        const result = pattern.test(url) && protocolCounts === 1;

        return {
            valid: result,
            message: !result
                ? t('Wrong link format, check for http / https at the beginning of the link')
                : undefined,
        };
    } catch (error) {
        console.error(error);

        return {
            valid: false,
            message: t('Wrong url address'),
        };
    }
};
